export const PAGE_SIZE = 10

export function validatePageSearch(search: Record<string, unknown>): {
  page?: number
} {
  const value = search.page
  return {
    page:
      value === undefined
        ? undefined
        : (typeof value === 'string' || typeof value === 'number') &&
            /^\d+$/.test(String(value)) &&
            Number.isSafeInteger(Number(value)) &&
            Number(value) > 0
          ? Number(value)
          : 0,
  }
}

// URLSearchParams preserves duplicates; Object.fromEntries would silently
// select one value and allow HTML and Markdown to disagree.
export function pageFromQuery(search: URLSearchParams) {
  const values = search.getAll('page')
  return values.length > 1 ? 0 : validatePageSearch({ page: values[0] }).page
}

export function paginate<T>(items: Array<T>, page = 1) {
  const totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE))
  return {
    posts: items.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    page,
    totalPages,
    totalItems: items.length,
    validPage: Number.isSafeInteger(page) && page >= 1 && page <= totalPages,
  }
}

export function pageUrl(base: string, page = 1) {
  return page > 1 ? `${base}?page=${page}` : base
}
